var _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 5,
    rx: 4,
    ry: 4
  }, /*#__PURE__*/React.createElement("animate", {
    id: "spinner_jbYs",
    begin: "0;spinner_JZdr.end",
    attributeName: "cy",
    calcMode: "spline",
    dur: "0.375s",
    values: "5;20",
    keySplines: ".33,0,.66,.33",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "spinner_jbYs.end",
    attributeName: "rx",
    calcMode: "spline",
    dur: "0.05s",
    values: "4;4.8;4",
    keySplines: ".33,0,.66,.33;.33,.66,.66,1"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "spinner_jbYs.end",
    attributeName: "ry",
    calcMode: "spline",
    dur: "0.05s",
    values: "4;3;4",
    keySplines: ".33,0,.66,.33;.33,.66,.66,1"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "spinner_ADF4",
    begin: "spinner_jbYs.end",
    attributeName: "cy",
    calcMode: "spline",
    dur: "0.025s",
    values: "20;20.5",
    keySplines: ".33,0,.66,.33"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "spinner_JZdr",
    begin: "spinner_ADF4.end",
    attributeName: "cy",
    calcMode: "spline",
    dur: "0.4s",
    values: "20.5;5",
    keySplines: ".33,.66,.66,1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.c4d0dc06c0c780d0138564a15fb58429.svg";
export { ForwardRef as ReactComponent };